import { render } from "./Register.vue?vue&type=template&id=e59c811e"
import script from "./Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/Register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e59c811e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e59c811e', __exports__)) {
    api.reload('e59c811e', __exports__)
  }
  
  module.hot.accept("./Register.vue?vue&type=template&id=e59c811e", () => {
    api.rerender('e59c811e', render)
  })

}


export default __exports__